"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvProgramDataFromJSON = TvProgramDataFromJSON;
exports.TvProgramDataFromJSONTyped = TvProgramDataFromJSONTyped;
exports.TvProgramDataToJSON = TvProgramDataToJSON;
exports.TvProgramDataToJSONTyped = TvProgramDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function TvProgramDataFromJSON(json) {
    return TvProgramDataFromJSONTyped(json, false);
}
function TvProgramDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'rtlklub': !(0, runtime_1.exists)(json, 'rtlklub') ? undefined : (0, _1.TvProgramByProgDaysFromJSON)(json['rtlklub']),
    };
}
function TvProgramDataToJSON(value) {
    return TvProgramDataToJSONTyped(value, false);
}
function TvProgramDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'rtlklub': (0, _1.TvProgramByProgDaysToJSON)(value.rtlklub),
    };
}
